import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useAppState } from 'src/shared/appState';
import { T } from './helpers';
import { SidebarOnboardingPanelFragment$key } from './__generated__/SidebarOnboardingPanelFragment.graphql';
import ToDoList from './ToDoList';
import TrialBanner from './TrialBanner';

const SidebarOnboardingPanel = () => {
    const { queryData } = useAppState();
    const query = useFragment<SidebarOnboardingPanelFragment$key>(
        graphql`
            fragment SidebarOnboardingPanelFragment on Query {
                user {
                    userID
                    email
                    name
                }
                testOrdersCount
                treeMenuReferringInfo {
                    daysOfTrial
                    firstNotPublishedProductID
                    hasFirstCustomizableProduct
                    hasPublishedProduct
                    hasStoreConnected
                    isAdministrator
                    isComposerEnabled
                    isExternalLinksHidden
                    isHelpWidgetHidden
                    isMenuHidden
                    isNoViewsPlan
                    isSubscriptionCanceled
                    isSubscriptionSubStatusBlocked
                    isToolbarHidden
                    isTrial
                    isVisibleSubscribePlan
                    noValidSubscriptionReason
                    planVersion
                    remoteUrl
                    sellerAppsumoMarketplaceID
                    subscriptionCancel
                    toolbarForceTools
                    urlComposer
                    userType
                }
            }
        `,
        queryData?.SidebarOnboardingPanelFragment ?? null
    );

    const daysOfTrial = query?.treeMenuReferringInfo.daysOfTrial;
    const isTrial = query?.treeMenuReferringInfo.isTrial ?? false;
    const isAdministrator = query?.treeMenuReferringInfo.isAdministrator ?? false;
    const planVersion = query?.treeMenuReferringInfo.planVersion ?? 2;
    const isVisibleSubscribePlan = query?.treeMenuReferringInfo.isVisibleSubscribePlan ?? false;
    const hasFirstCustomizableProduct = query?.treeMenuReferringInfo.hasFirstCustomizableProduct ?? false;
    const hasStoreConnected = query?.treeMenuReferringInfo.hasStoreConnected ?? false;
    const hasPlaceTestOrder = (query?.testOrdersCount ?? 0) > 0;

    const steps = [
        { completed: true, text: T._('Signup', 'Admin'), url: undefined },
        { completed: true, text: T._('Start free trial', 'Admin'), url: undefined },
        {
            completed: true,
            text: T._('Understanding Zakeke', 'Admin'),
            url: 'https://zakeke.zendesk.com/hc/en-us/articles/360021604400-Understanding-Zakeke'
        },
        {
            completed: hasFirstCustomizableProduct,
            text: T._('Create your first customizable product', 'Admin'),
            url: 'https://zakeke.zendesk.com/hc/en-us/articles/6396920276124'
        },
        {
            completed: hasStoreConnected,
            text: T._('Connect your eStore', 'Admin'),
            url: 'https://zakeke.zendesk.com/hc/en-us/articles/360026666973-Installing-Zakeke'
        },
        {
            completed: hasPlaceTestOrder,
            text: T._('Place a test order', 'Admin'),
            url: 'https://zakeke.zendesk.com/hc/en-us/articles/360018551700-How-to-test-a-customizable-product-and-place-a-test-order'
        }
    ];
    const numCompleted = steps.filter((s) => s.completed).length;

    return (
        <>
            {!isAdministrator && planVersion === 2 && <ToDoList steps={steps} numCompleted={numCompleted} />}

            {isTrial && <TrialBanner daysOfTrial={daysOfTrial ?? 9} isVisibleSubscribePlan={isVisibleSubscribePlan} />}
        </>
    );
};

export default SidebarOnboardingPanel;
